import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Profile } from 'src/app/modules/shared/models/profile.mode';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { DynamicScript } from 'src/app/modules/shared/services/dynamic-script.service';
import { ProfileResolverService } from 'src/app/modules/shared/services/resolver/profile-resolver.service';
import { SnackBarService } from 'src/app/modules/shared/services/snack-bar.service';
import { LocalStorageService } from 'src/app/modules/shared/services/storage/local-storage.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { LogoutDialogComponent } from '../logout-dialog/logout-dialog.component';
import { initializeApp } from 'firebase/app';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { isPlatformBrowser } from '@angular/common';
import { DeviceDetectorService } from 'src/app/modules/shared/services/device-detector/device-detector.service';
import { PreferenceService } from 'src/app/modules/shared/services/preference/preference.service';
import { KingClubAssets } from 'src/app/modules/shared/enum/icons';
declare const AppleID: any;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  showTab: string;
  userProfile: Profile | any;
  isAppleConnected: boolean = false;
  isShowBack: boolean = false;
  isGoogleConnected: boolean = false;
  storeDetail: any;
  platformId: Object;
  storeRegionInfo: any;
  isLoggedIn: boolean = false;
  selectedThemeIndex: number = 0;
  isDesktop: boolean = false;
  clubIcons = KingClubAssets;

  constructor(
    private profileResolver: ProfileResolverService,
    private panelService: PanelService,
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private loadScript: DynamicScript,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private preferenceService: PreferenceService,
    private storeDetailResolver: StoreDetailService,
    private deviceDetectorService: DeviceDetectorService,
    @Inject(PLATFORM_ID) platFormId: Object
  ) {
    this.platformId = platFormId;
    this.isDesktop = this.deviceDetectorService.isDesktop;
    this.isLoggedIn = this.localStorageService.isLoggedIn;
    if (!this.isLoggedIn && this.isDesktop) {
      this.router.navigate(['/authenticate/login']);
    }
    if (this.isDesktop) {
      this.activatedRoute.params.subscribe((params) => {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      });
    }
  }

  ngOnInit(): void {
    this.storeRegionInfo = this.localStorageService.getItem('store-region');
    this.getStoreDetail();
    if (
      this.isDesktop &&
      this.isLoggedIn &&
      !this.activatedRoute.snapshot.queryParams.tab
    ) {
      this.setDefaultActiveTab();
    }
    this.setRouteParam();
    this.profileResolver.permissionInitInfo.subscribe((data) => {
      this.userProfile = data;
    });
    this.loadAppleAuth();
  }

  openPreference() {
    this.preferenceService.openPreference();
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
    initializeApp(this.storeDetail?.firebase_config);
  }

  ngOnDestroy() {
    document.removeEventListener(
      'AppleIDSignInOnSuccess',
      this.appleSuccessConnect
    );
    document.removeEventListener(
      'AppleIDSignInOnFailure',
      this.appleErrorConnect
    );
  }

  setRouteParam() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.tab) {
        this.showTab = params.tab;
      }
    });
  }

  setDefaultActiveTab() {
    this.showTab = 'edit';
    this.activeTab(this.showTab);
  }

  activeTab(activeTab) {
    this.router.navigate(['/profile'], { queryParams: { tab: activeTab } });
  }

  setCurrentRoute(link) {
    this.router.navigate([link]);
  }

  logOut() {
    this.dialog.open(LogoutDialogComponent, {
      width: '350px',
      height: '200px',
      panelClass: 'logout-dialog',
    });
  }

  closeDialogs() {
    this.dialog.closeAll();
  }

  loadAppleAuth() {
    this.loadScript.loadAppleScript().then(() => {
      let redirectURI;
      if (isPlatformBrowser(this.platformId)) {
        redirectURI = window.location.origin;
      }

      AppleID.auth.init({
        clientId: environment.appleClientId,
        scope: 'name email',
        redirectURI: redirectURI,
        state: '',
        usePopup: true,
      });
    });

    document.addEventListener(
      'AppleIDSignInOnSuccess',
      this.appleSuccessConnect
    );
    document.addEventListener('AppleIDSignInOnFailure', this.appleErrorConnect);
  }

  appleSuccessConnect = (data) => {
    if ((<any>data).detail?.authorization?.id_token) {
      this.connectToApple((<any>data).detail?.authorization?.id_token);
    }
  };

  appleErrorConnect = (error) => {
    this.snackBarService.showSnackBar(
      (<any>error).detail?.error,
      'primary',
      2000
    );
  };

  connectToApple(token) {
    this.panelService.appleConnect({ token }).subscribe((res) => {
      this.profileResolver.updateInfo();
      this.isAppleConnected = true;
    });
  }

  backButton() {
    this.showTab = '';
    this.router.navigate(['/profile']);
  }

  changeSelection(event, index) {
    this.selectedThemeIndex = event.checked ? index : undefined;
  }

  setWalletChargeTab(isChargeWallet: boolean) {
    if (isChargeWallet) {
      this.showTab = 'wallet-charge';
      this.activeTab(this.showTab);
    }
  }
}
